export const UPDATE_BATCH_FORM =
	'SALES_CONFIGURATION_PRODUCT_BUNDLE_SET_PRODUCT_VARIANTS/UPDATE_BATCH_FORM';
export const ADD_BATCH_LIST =
	'SALES_CONFIGURATION_PRODUCT_BUNDLE_SET_PRODUCT_VARIANTS/ADD_BATCH_LIST';
export const EDIT_BATCH_LIST_ITEM =
	'SALES_CONFIGURATION_PRODUCT_BUNDLE_SET_PRODUCT_VARIANTS/EDIT_BATCH_LIST_ITEM';
export const REMOVE_BATCH_LIST_ITEM =
	'SALES_CONFIGURATION_PRODUCT_BUNDLE_SET_PRODUCT_VARIANTS/REMOVE_BATCH_LIST_ITEM';

export const SET_PRODUCT_BUNDLE_SET_PRODUCT_VARIANTS =
	'SALES_CONFIGURATION_PRODUCT_BUNDLE_SET_PRODUCT_VARIANTS/SET_PRODUCT_BUNDLE_SET_PRODUCT_VARIANTS';
export const UPDATE_PRODUCT_BUNDLE_SET_PRODUCT_VARIANTS =
	'SALES_CONFIGURATION_PRODUCT_BUNDLE_SET_PRODUCT_VARIANTS/UPDATE_PRODUCT_BUNDLE_SET_PRODUCT_VARIANTS';
export const RESET_STATE =
	'SALES_CONFIGURATION_PRODUCT_BUNDLE_SET_PRODUCT_VARIANTS/RESET_STATE';

export function setProductBundleSetProductVariants(payload) {
	return {
		type: SET_PRODUCT_BUNDLE_SET_PRODUCT_VARIANTS,
		payload
	};
}

export function updateProductBundleSetProductVariants(payload) {
	return {
		type: UPDATE_PRODUCT_BUNDLE_SET_PRODUCT_VARIANTS,
		payload
	};
}

export function updateBatchForm(payload) {
	return {
		type: UPDATE_BATCH_FORM,
		payload
	};
}

export function addBatchList(payload) {
	return {
		type: ADD_BATCH_LIST,
		payload
	};
}

export function editBatchListItem(payload) {
	return {
		type: EDIT_BATCH_LIST_ITEM,
		payload
	};
}

export function removeBatchListItem(payload) {
	return {
		type: REMOVE_BATCH_LIST_ITEM,
		payload
	};
}

export function resetState() {
	return {
		type: RESET_STATE
	};
}
